export function getAuthHeader(user) {
  return {
    "Access-Control-Allow-Origin": true,
    Authorization: `Bearer ${user.token}`
  };
}
